'use es6';

import UsageLimits from '../models/UsageLimits';
import { REQUESTED_CONTENT_USAGE_LIMITS, RECEIVED_CONTENT_USAGE_LIMITS, REQUESTED_CONTENT_USAGE_LIMITS_FAILED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new UsageLimits(), action) => {
  switch (action.type) {
    case REQUESTED_CONTENT_USAGE_LIMITS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_CONTENT_USAGE_LIMITS:
      {
        return state.merge(Object.assign({}, action.payload, {
          status: RequestStatus.SUCCEEDED
        }));
      }
    case REQUESTED_CONTENT_USAGE_LIMITS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});